import { TokenAuth, SignalRApi, JsonApi, ApiAuthChallenge, PopupAuthChallenge, FrameAuthChallenge } from '@kanbo/api'
import { MsTeamsAuthChallenge, isInsideMsTeams } from '@kanbo/api-ms-teams'
// eslint-disable-next-line import/no-webpack-loader-syntax
import HeartbeatWorker from 'worker-loader?worker=SharedWorker!./heartbeat.worker.js'

let url = ''
if (process.env.NODE_ENV === 'development') {
  url = process.env.KANBO_URL
}

let heartbeatWorker
if (window.SharedWorker) {
  heartbeatWorker = new HeartbeatWorker()

  heartbeatWorker.port.start()
}

const auth = new TokenAuth({
  url,
  authChallenges:
    isInsideMsTeams()
      ? [
        new MsTeamsAuthChallenge()
      ] : [
        new ApiAuthChallenge(),
        new PopupAuthChallenge(),
        new FrameAuthChallenge()
      ],
  onTokenChange: (token) => {
    if (heartbeatWorker) heartbeatWorker.port.postMessage(token)
  }
})

const KanBoApi = new SignalRApi({
  auth,
  url,
})

export const KanBoJsonApi = new JsonApi({
  auth,
  url,
})

if (process.env.NODE_ENV === 'development') {
  window.KanBoAuth = auth
  window.KanBoApi = KanBoApi
  window.KanBoJsonApi = KanBoJsonApi
}

export const joinChannel = KanBoApi.joinChannel

export const partChannel = KanBoApi.partChannel

export const getData = KanBoApi.getData

export const getDataAll = KanBoApi.getDataAll

export const action = KanBoApi.action

export const actionSequence = KanBoApi.actionSequence

export default KanBoApi
